import {AlertCircle, CheckCircle2, Clock3, Target} from 'lucide-react'
import {useApp} from '../../context/AppContext'

export default function StatsGrid() {
  const {state} = useApp()

  const totalTasks = state.tasks.length
  const inProgress = state.tasks.filter((task) => task.status === 'in_progress').length
  const completed = state.tasks.filter((task) => task.status === 'done').length
  const overdue = state.tasks.filter((task) => {
    if (!task.dueDate || task.status === 'done') return false
    return new Date(task.dueDate) < new Date()
  }).length
  const completionRate = totalTasks ? Math.round((completed / totalTasks) * 100) : 0

  const stats = [
    {
      label: 'Total de tarefas',
      value: totalTasks,
      detail: `${state.boards.length} quadros ativos`,
      icon: Target,
      iconClass: 'text-brand-600 bg-brand-50',
      accent: 'bg-brand-500',
    },
    {
      label: 'Em andamento',
      value: inProgress,
      detail: totalTasks
        ? `${Math.round((inProgress / totalTasks) * 100)}% do volume`
        : 'Sem tarefas',
      icon: Clock3,
      iconClass: 'text-amber-600 bg-amber-50',
      accent: 'bg-amber-500',
    },
    {
      label: 'Concluídas',
      value: completed,
      detail: `${completionRate}% de conclusão`,
      icon: CheckCircle2,
      iconClass: 'text-emerald-600 bg-emerald-50',
      accent: 'bg-emerald-500',
    },
    {
      label: 'Precisam de atenção',
      value: overdue,
      detail: overdue === 1 ? '1 prazo vencido' : `${overdue} prazos vencidos`,
      icon: AlertCircle,
      iconClass: 'text-red-600 bg-red-50',
      accent: 'bg-red-500',
    },
  ]

  return (
    <section
      className='grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4'
      aria-label='Indicadores principais'
    >
      {stats.map((stat, index) => (
        <article
          key={stat.label}
          className='devops-stat-card p-4 md:p-5 animate-slide-in-up'
          style={{animationDelay: `${index * 45}ms`}}
        >
          <span className={`absolute inset-x-0 top-0 h-[3px] ${stat.accent}`} />
          <div className='relative z-[1] flex items-start justify-between gap-3'>
            <div>
              <p className='text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-400'>
                {stat.label}
              </p>
              <p className='mt-2 text-2xl md:text-3xl font-bold tracking-[-0.04em] text-slate-800'>
                {stat.value}
              </p>
              <p className='mt-1 text-[11px] text-slate-500'>{stat.detail}</p>
            </div>
            <span
              className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${stat.iconClass}`}
            >
              <stat.icon size={19} strokeWidth={1.9} />
            </span>
          </div>
        </article>
      ))}
    </section>
  )
}
